(function ($) {
	window.SET_SMOOTHSCROLLERS = function ($defaultTriggers = null) {
		// get the triggers these either start with # or are an absolute link to the current page with a hash
		let $triggers = $defaultTriggers;

		if (!$triggers) {
			$triggers = $(
				'a[href^="#"]:not(.js-smooth-scroll), a[href^="' +
					location.origin +
					location.pathname +
					'#"]:not(.js-smooth-scroll)',
			);
		}

		if (!$triggers.length) {
			return;
		}

		$triggers.each(function () {
			const $trigger = $(this);

			// get the hash from the href
			const id = $trigger.attr('href').split('#')[1];

			if (id === '#') {
				return;
			}

			// check if a target element exists by id or by name
			const target = document.getElementById(id) || document.querySelector(`[name="${id}"]`);

			if (!target) {
				return;
			}

			$trigger.data('scroll-target', $(target));
			$trigger.data('scroll-id', id);
			$trigger.addClass('js-smooth-scroll');
			$trigger.off('click', smoothScrollTo);
			$trigger.on('click', smoothScrollTo);
		});
	};

	function smoothScrollTo(e) {
		e.preventDefault();

		const $target = $(this).data('scroll-target');
		const id = $(this).data('scroll-id');

		if (!$target || !$target.length) {
			return;
		}

		let scrollTop = $target.offset().top;

		if ($target.hasClass('is-style-sticky') || $target.closest('.is-style-sticky').length) {
			const $notStickyParent = $target.closest(
				'.wp-block-columns, .wp-block-cover, .entry-content',
			);

			scrollTop = $notStickyParent.offset().top;
		}

		if ($('.intervention-page__nav').length) {
			scrollTop -= $('.intervention-page__nav').outerHeight() + 24;
		}

		history.replaceState(null, null, `#${id}`);

		$('html, body').animate(
			{
				scrollTop,
			},
			300,
			'linear',
			() => {
				$target.attr('tabindex', '-1').focus();
			},
		);
	}

	window.SET_SMOOTHSCROLLERS();
})(jQuery);
